'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _mobx = require('mobx');

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PlaintiffStore = (_class = function () {
  function PlaintiffStore(caseStore, transport) {
    _classCallCheck(this, PlaintiffStore);

    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(PlaintiffStore, [{
    key: 'update',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var caseId = _ref2.caseId,
            plaintiffData = _ref2.plaintiffData,
            plaintiffId = _ref2.plaintiffId;
        var plaintiff;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.transport.put('/plaintiffs/:plaintiffId/', {
                  data: plaintiffData,
                  urlParams: { plaintiffId: plaintiffId }
                });

              case 2:
                plaintiff = _context.sent;


                this.caseStore.setPlaintiff({ caseId: caseId, plaintiff: plaintiff });

                return _context.abrupt('return', plaintiff);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x) {
        return _ref.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PlaintiffStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype)), _class);
var _default = PlaintiffStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PlaintiffStore, 'PlaintiffStore', '/app/src/stores/PlaintiffStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/PlaintiffStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zdG9yZXMvUGxhaW50aWZmU3RvcmUuanMiXSwibmFtZXMiOlsiUGxhaW50aWZmU3RvcmUiLCJjYXNlU3RvcmUiLCJ0cmFuc3BvcnQiLCJjYXNlSWQiLCJwbGFpbnRpZmZEYXRhIiwicGxhaW50aWZmSWQiLCJwdXQiLCJkYXRhIiwidXJsUGFyYW1zIiwicGxhaW50aWZmIiwic2V0UGxhaW50aWZmIiwiYWN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBR01BLGM7QUFHSiwwQkFBYUMsU0FBYixFQUF3QkMsU0FBeEIsRUFBbUM7QUFBQTs7QUFDakMsU0FBS0QsU0FBTCxHQUFpQkEsU0FBakI7QUFDQSxTQUFLQyxTQUFMLEdBQWlCQSxTQUFqQjtBQUNEOzs7Ozs7WUFHZUMsTSxTQUFBQSxNO1lBQVFDLGEsU0FBQUEsYTtZQUFlQyxXLFNBQUFBLFc7Ozs7Ozs7dUJBQ2IsS0FBS0gsU0FBTCxDQUFlSSxHQUFmLENBQW1CLDJCQUFuQixFQUFnRDtBQUN0RUMsd0JBQU1ILGFBRGdFO0FBRXRFSSw2QkFBVyxFQUFFSCx3QkFBRjtBQUYyRCxpQkFBaEQsQzs7O0FBQWxCSSx5Qjs7O0FBS04scUJBQUtSLFNBQUwsQ0FBZVMsWUFBZixDQUE0QixFQUFFUCxjQUFGLEVBQVVNLG9CQUFWLEVBQTVCOztpREFFT0EsUzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7NkRBVFJFLFk7ZUFhWVgsYzs7Ozs7Ozs7Ozs7MEJBckJUQSxjIiwiZmlsZSI6IlBsYWludGlmZlN0b3JlLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBhY3Rpb24gfSBmcm9tICdtb2J4JztcblxuXG5jbGFzcyBQbGFpbnRpZmZTdG9yZSB7XG4gIGNhc2VTdG9yZTtcblxuICBjb25zdHJ1Y3RvciAoY2FzZVN0b3JlLCB0cmFuc3BvcnQpIHtcbiAgICB0aGlzLmNhc2VTdG9yZSA9IGNhc2VTdG9yZTtcbiAgICB0aGlzLnRyYW5zcG9ydCA9IHRyYW5zcG9ydDtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgdXBkYXRlICh7IGNhc2VJZCwgcGxhaW50aWZmRGF0YSwgcGxhaW50aWZmSWQgfSkge1xuICAgIGNvbnN0IHBsYWludGlmZiA9IGF3YWl0IHRoaXMudHJhbnNwb3J0LnB1dCgnL3BsYWludGlmZnMvOnBsYWludGlmZklkLycsIHtcbiAgICAgIGRhdGE6IHBsYWludGlmZkRhdGEsXG4gICAgICB1cmxQYXJhbXM6IHsgcGxhaW50aWZmSWQgfSxcbiAgICB9KTtcblxuICAgIHRoaXMuY2FzZVN0b3JlLnNldFBsYWludGlmZih7IGNhc2VJZCwgcGxhaW50aWZmIH0pO1xuXG4gICAgcmV0dXJuIHBsYWludGlmZjtcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBQbGFpbnRpZmZTdG9yZTtcbiJdfQ==